import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';
import BASEAPI from "@/util/BASEAPI";

@Component({})
export default class OCProductCard extends Mixins(BASEComponentVue) {
    @Prop({
        type: Object,
        default: () => { return { "id": "0" } }
    })
    product!: BASEAPI.Product;

    @Prop({
        type: Array,
        default: []
    })
    imgList!: {img: string, title: string}[];

    @Prop({
        type: String,
        default: ""
    })
    date!: string;

    @Prop({
        type: String,
        default: "start"
    })
    type!: string;
}
